import React, { Suspense, useState, useEffect, useRef } from "react";
import { Modal } from 'react-responsive-modal';
import dataLoaderServices from "./DataLoaderServices";

export default function DataLoaderLoadFile(param: any) {

    const [upLoadedCount, setUpLoadedCount] = useState(0)

    const returnValue = (e: any) => {
        param.onChangeLoadFile(e)
    }

    useEffect(() => {
        if (param.type === 'Contacts') { dataLoaderServices.dataLoadContactCount().then((value: any) => { setUpLoadedCount(value) }) }

        if (param.type === 'Contracts') { dataLoaderServices.dataLoadContractCount().then((value: any) => { setUpLoadedCount(value) }) }

        if (param.type === 'Contract Links') { dataLoaderServices.dataLoadcontractLinksCount().then((value: any) => { setUpLoadedCount(value) }) }

        if (param.type === 'Song') { dataLoaderServices.songLoaderCount().then((value: any) => { setUpLoadedCount(value) }) }

        if (param.type === 'Data Transfer') { dataLoaderServices.dataTransferCount(param.subType).then((value: any) => { setUpLoadedCount(value) }) }

        if (param.type === 'Minimum Set Uploader') { dataLoaderServices.minimumSetMetaData({ type: param.subType }).then((value: any) => { setUpLoadedCount(value) }) }

        if (param.type === 'Upload Mechanical') {
            if (param.subType) {
                dataLoaderServices.dataLoadMechanicalUploadCount({ type: param.subType }).then((value: any) => { setUpLoadedCount(value) })
            }
        }

        if (param.type === 'Mappings') {
            if (param.subType) {
                dataLoaderServices.dataLoadMappingCount({ type: param.subType }).then((value: any) => { setUpLoadedCount(value) })
            }
        }

        if (param.type === 'Bulk Update') {
            if (param.subType) {
                dataLoaderServices.bulkUpdateSummary({ type: param.subType }).then((value: any) => { setUpLoadedCount(value) })
            }
        }

        if (param.type === 'Release/Track') {
            if (param.subType == "releaseTrack" || param.subType == "Distributor") {
                dataLoaderServices.genericV1Count().then((value: any) => { setUpLoadedCount(value) })
            }
            if (param.subType == "Releases") {
                dataLoaderServices.genericV1TypeCount({ type: "release" }).then((value: any) => { setUpLoadedCount(value) })
            }

            if (param.subType == "Track") {
                dataLoaderServices.genericV1TypeCount({ type: "track" }).then((value: any) => { setUpLoadedCount(value) })
            }
        }

        if (param.type === 'suggestedPayments') {
            if (param.subType) {
                dataLoaderServices.suggestedPaymentsCount().then((value: any) => { setUpLoadedCount(value) })
            }
        }

    }, [param.open]);

    return (
        <div className="ws-6">

            <Modal open={param.open} onClose={() => returnValue(0)} styles={{ modalContainer: { background: 'transparent !important', width: "50% !important" } }} center classNames={{ overlay: '', modal: 'ws-5 paddingCenterBox bgTransparent' }} >

                <div className=" ws-12 box-header-fix box" >

                    <div className="box-header-main">  <h2><i className="fa fa-question-circle"></i> Clear or Append Data?</h2> </div>

                    {upLoadedCount > 0 && <div className="box-content test"><span>Do you want to clean previous data or append new data ?</span></div>}
                    {upLoadedCount == 0 && <div className="box-content test"><span>Do you want to load data  ?</span></div>}

                    <div className="ws-12 pm">
                        {(upLoadedCount === 0) && <>
                            <button className="icon-btn primary width100 height35 pull-right" onClick={() => returnValue(3)} > Load</button>
                            <button className="icon-btn delete width100 height35 pull-right" onClick={() => returnValue(0)} > Cancel</button>
                        </>}
                        {(upLoadedCount > 0) && <>
                            <button className="icon-btn delete width90 height35 pull-right" onClick={() => returnValue(1)} > Append</button>
                            <button className="icon-btn primary width90 height35 pull-right" onClick={() => returnValue(2)} > Clear</button></>}
                    </div>

                </div>
            </Modal>
        </div>
    )
}